import { arcTeamMemberService } from './arcTeamMemberService'

/**
 * The arc-team-member module façade. No store: every page that shows members loads them for the team
 * it is displaying, and membership is never cached across teams.
 */
export const useArcTeamMember = () => {
  return {
    arcTeamMember: {
      service: arcTeamMemberService()
    }
  }
}
